import { teamManagerViewType } from '@models/manager/account/account';
import TeamList from './teamList';
import MemberList from './memberList';
import { useSelector } from 'react-redux';
import { RootState } from '@reducers/index';

const TopInfo = ({ memberListFilterHandler }) => {
  const { quotaInfo, viewState } = useSelector(({ team }: RootState) => team);
  return (
    <>
      <div className="t-manager">
        <h2 className="t-manager-tit">Team Manager</h2>
        <span className="t-manager-use">
          Use {quotaInfo.use} : Quota {quotaInfo.quota}
        </span>
      </div>
      {/* teamList 그리드차트시  */}
      {viewState === teamManagerViewType.teamList && <TeamList />}
      {/* memberList 그리드차트시 */}
      {viewState === teamManagerViewType.memberList && <MemberList searchObjHandler={memberListFilterHandler} />}
    </>
  );
};

export default TopInfo;
